module.exports = __webpack_public_path__ + "img/instagram.aa9ae8da.jpg";